"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsPage = TermsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var legal_page_layout_1 = require("../components/legal/legal-page-layout");
var terms_data_1 = require("../data/terms.data");
function TermsPage() {
    return (0, jsx_runtime_1.jsx)(legal_page_layout_1.LegalPageLayout, { legalDocument: terms_data_1.TERMS_AND_CONDITIONS });
}
